<div class="document-acceptance">
  <div class="checkbox" (click)="onAcceptanceChange()" (keydown.space)="onAcceptanceChange()" tabindex="0">
    <img *ngIf="isAccepted" src="assets/images/icons/check-red.svg" />
  </div>
  <div class="texts">
    <div class="acceptance-title">{{ title }}</div>
    <div class="lead">{{ lead }}<br /><a [href]="link" target="_blank">{{ title }}</a></div>
  </div>
</div>
<app-error-message *ngIf="!isAccepted && formControl.touched" [validationErrors]="required ? { required: true } : null"></app-error-message>
